<template>
    <div class="wlx-news-backstage-wrapper">
        <div class="yk-wrap-fixeds">
            <header class="u-school-manager-head">
                <el-form :inline="true" size="small">
                    <div class="dd-search-form-news">
                        <el-form-item>
                            <el-input v-model="title" placeholder="请输标题" clearable></el-input>
                        </el-form-item>
                        <el-form-item>
                            <el-select v-model="value" placeholder="请选择" clearable>
                                <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" icon="el-icon-search" @click="search">搜索</el-button>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" icon="el-icon-circle-plus-outline" @click="add">添加</el-button>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" icon="el-icon-delete" @click="deleteAll">删除</el-button>
                        </el-form-item>
                    </div>
                </el-form>
            </header>
            <!-- 新增新闻 -->
            <el-dialog title="新增新闻" v-if="addNewNoticeVisible" :visible.sync="addNewNoticeVisible" :before-close="cancel" :append-to-body="true" width="70%" :close-on-click-modal="false">
                <div>
                    <el-form ref="ruleForm" label-width="80px">
                        <el-form-item label="新闻标题" prop="title">
                            <el-input v-model="title"></el-input>
                        </el-form-item>
                        <el-form-item label="类型" style="80px">
                            <el-radio-group v-model="newsType">
                                <el-radio :label="1">新闻</el-radio>
                                <el-radio :label="2">通告</el-radio>
                            </el-radio-group>
                        </el-form-item>
                        <el-form-item label="新闻内容">
                            <Editor :config="editorconfig" v-model="content" placeholder="请输入内容" />
                        </el-form-item>
                        <el-form-item label="新闻封面">
                            <imageUpload :url="urlAliyunOSS" :files.sync="avatorUrl" format="image"></imageUpload>
                        </el-form-item>
                        <el-form-item label="发布时间">
                            <el-date-picker v-model="pulishTime" type="datetime" placeholder="选择日期"></el-date-picker>
                        </el-form-item>
                        <!-- <el-form-item label="新闻排序"
                            prop="orderNumber">
                <el-input v-model="orderNumber"></el-input> 
            </el-form-item>-->
                    </el-form>
                </div>
                <span slot="footer" class="dialog-footer">
                    <el-button @click="cancel">取 消</el-button>
                    <el-button type="primary" @click="addSchoolNews()">确 定</el-button>
                </span>
            </el-dialog>
            <!--编辑-->
            <el-dialog title="编辑新闻" v-if="editNoticeVisible" :visible.sync="editNoticeVisible" :before-close="cancel" :append-to-body="true" width="70%" :close-on-click-modal="false">
                <div>
                    <el-form ref="ruleForm" label-width="80px">
                        <el-form-item label="新闻标题" prop="title">
                            <el-input v-model="title"></el-input>
                        </el-form-item>
                        <el-form-item label="类型" style="80px">
                            <el-radio-group v-model="newsType">
                                <el-radio :label="1">新闻</el-radio>
                                <el-radio :label="2">通告</el-radio>
                            </el-radio-group>
                        </el-form-item>
                        <el-form-item label="新闻内容">
                            <Editor :config="editorconfig" v-model="content" placeholder="请输入内容" />
                        </el-form-item>
                        <el-form-item label="新闻封面">
                            <imageUpload :url="urlAliyunOSS" :files.sync="avatorUrl" format="image"></imageUpload>
                        </el-form-item>
                        <el-form-item label="发布时间">
                            <el-date-picker v-model="pulishTime" type="datetime" placeholder="选择日期"></el-date-picker>
                        </el-form-item>
                        <el-form-item label="新闻排序" prop="orderNumber">
                            <el-input v-model="orderNumber"></el-input>
                        </el-form-item>
                    </el-form>
                </div>
                <span slot="footer" class="dialog-footer">
                    <el-button @click="cancel">取 消</el-button>
                    <el-button type="primary" @click="editSchoolNews()">确 定</el-button>
                </span>
            </el-dialog>
            <!-- 查看新闻弹框 -->
            <el-dialog title="查看新闻" v-if="viewNoticeVisible" :visible.sync="viewNoticeVisible" :before-close="cancel" :append-to-body="true" width="70%" :close-on-click-modal="false">
                <div>
                    <el-form ref="ruleForm" label-width="80px" disabled>
                        <el-form-item label="新闻标题" prop="title">
                            <el-input v-model="title"></el-input>
                        </el-form-item>
                        <el-form-item label="新闻内容">
                            <Editor :config="editorconfig" v-model="content" placeholder="请输入内容" />
                        </el-form-item>
                        <el-form-item label="新闻封面">
                            <imageUpload :url="urlAliyunOSS" :files.sync="avatorUrl" format="image"></imageUpload>
                        </el-form-item>
                    </el-form>
                </div>
                <span slot="footer" class="dialog-footer">
                    <el-button type="primary" @click="cancel">确 定</el-button>
                </span>
            </el-dialog>
            <div class="u-table-main">
                <el-table ref="multipleeeeTable" :data="list" tooltip-effect="dark" @selection-change="handleSelectionChange">
                    <el-table-column prop="id" type="selection" width="55"></el-table-column>
                    <el-table-column label="序号" type="index" width="50"></el-table-column>
                    <el-table-column label="新闻标题" :show-overflow-tooltip="true" width="300">
                        <template slot-scope="scope">
                            <p v-html="scope.row.title" class="scope-p"></p>
                        </template>
                    </el-table-column>
                    <el-table-column label="内容" :show-overflow-tooltip="true">
                        <template slot-scope="scope">
                            <p v-html="scope.row.contentText" class="scope-p"></p>
                        </template>
                    </el-table-column>
                    <el-table-column prop="dateCreated" label="创建时间" width="160"></el-table-column>
                    <!-- <el-table-column prop="associationName" label="创建人" width="180"></el-table-column> -->
                    <el-table-column prop="orderNumber" label="排序" width="60"></el-table-column>
                    <el-table-column prop="newsType" label="类型" width="100">
                        <template slot-scope="scope">
                            <span v-if="scope.row.type == 1">新闻</span>
                            <span v-else>通告</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="pulishTime" label="发布时间" width="160"></el-table-column>
                    <el-table-column label="操作" width="180">
                        <template slot-scope="scope">
                            <el-tooltip class="item" effect="dark" content="编辑" placement="top-start">
                                <el-button size="mini" class="el-icon-edit" @click="edit(scope.row)" type="primary"></el-button>
                            </el-tooltip>
                            <!-- <el-button
                size="mini"
                type="primary"
                class="el-icon-view"
                @click="viewSchoolNews(scope.row)"
                title="查看"
              ></el-button> -->
                            <el-tooltip class="item" effect="dark" content="删除" placement="top-start">
                                <el-button size="mini" type="danger" class="el-icon-delete" @click="deleteMajor(scope.row.id)"></el-button>
                            </el-tooltip>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div class="news-page-con">
                <el-pagination background @size-change="handleSizeChange" @current-change="onPageChangeHandler" :current-page="pageIndex" :page-sizes="[10, 25, 50, 100]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total" v-show="total > 0"></el-pagination>
            </div>
        </div>
    </div>
</template>

<script>
import imageUpload from "components/imageUpload.vue";
export default {
    data() {
        return {
            list: [],
            total: 0,
            pageSize: 10,
            pageIndex: 1,
            addNewNoticeVisible: false,
            editNoticeVisible: false,
            viewNoticeVisible: false,
            /* -----------添加/修改弹框参数------------ */
            sTitle: "",
            title: "",
            content: "",
            avatorUrl: "",
            newsType: 1,
            orderNumber: 0,
            pulishTime: "",
            /* --------------------------------------- */
            id: "",
            ids: [],
            // noDataShow: false,
            options: [
                {
                    label: "新闻",
                    value: 1,
                },
                {
                    label: "通告",
                    value: 2,
                },
            ],
            value: "",
            schoolnewsId: "",
            urlAliyunOSS: "/api/design/osssign/getsign",
            editorconfig: {
                toolbarButtons: [
                    "undo",
                    "redo",
                    "bold",
                    "underline",
                    "strikeThrough",
                    'quote',
                    'clearFormatting',
                    "|",
                    "align",
                    "formatOL",
                    "formatUL",
                    'insertTable',
                    "|",
                    "insertLink",
                    "insertImage",
                    "insertVideo",
                    // 'insertFile'
                ],
            },
        };
    },
    components: {
        imageUpload,
    },
    created() {
        this.school = this.$store.state.auth.userName;
        this.getSchoolNewsList();
    },
    methods: {
        getSchoolNewsList(page) {
            var that = this;
            this.$http
                .post("/api/XOrg/AssociationNews/getNewsList", {
                    page: page,
                    pageSize: this.pageSize,
                    title: that.title,
                    value: that.value,
                })
                .then((rst) => {
                    if (rst.code == 1) {
                        this.list = rst.list;
                        this.total = rst.pagination.totalCount;
                        this.pageSize = rst.pagination.pageSize;
                        this.pageIndex = rst.pagination.pageIndex;
                        this.cancel();
                    } else {
                        this.$message.warning(rst.msg);
                    }
                });
        },
        onPageChangeHandler(page) {
            this.getSchoolNewsList(page);
        },
        handleSizeChange(val) {
            this.pageSize = val;
            this.getSchoolNewsList();
        },
        handleSelectionChange(val) {
            this.ids = [];
            val.forEach((element) => {
                this.ids.push(element.id);
            });
        },
        cancel() {
            (this.addNewNoticeVisible = false), (this.editNoticeVisible = false), (this.viewNoticeVisible = false), (this.title = ""), (this.content = ""), (this.avatorUrl = "");
            this.newsType = 1;
            this.pulishTime = "";
        },
        addSchoolNews() {
            var that = this;
            this.$http
                .post("/api/XOrg/AssociationNews/addNews", {
                    title: that.title,
                    content: that.content,
                    cover: that.avatorUrl,
                    type: that.newsType,
                    pulishTime: that.pulishTime,
                })
                .then((rst) => {
                    if (rst.code === 1) {
                        that.cancel();
                        that.$message({
                            showClose: true,
                            message: rst.msg,
                            type: "success",
                        });
                        that.getSchoolNewsList();
                    } else {
                        that.$message.warning(rst.msg);
                    }
                });
        },
        viewSchoolNews(row) {
            this.title = row.title;
            this.description = row.description;
            this.imageUrl = row.cover;
            this.viewNoticeVisible = true;
        },
        editSchoolNews() {
            var that = this;
            debugger;
            if (that.orderNumber < 0) {
                that.$message.warning("填写正确序号");
            } else {
                this.$http
                    .post("/api/XOrg/AssociationNews/editNews", {
                        newsId: that.schoolnewsId,
                        title: that.title,
                        content: that.content,
                        cover: that.avatorUrl,
                        type: that.newsType,
                        pulishTime: that.pulishTime,
                        orderNumber: that.orderNumber,
                    })
                    .then((rst) => {
                        if (rst.code === 1) {
                            that.cancel();
                            that.$message({
                                message: rst.msg,
                                type: "success",
                            });
                            that.editNoticeVisible = false;
                            that.getSchoolNewsList();
                        } else {
                            that.$message.warning(rst.msg);
                        }
                    });
            }
        },
        add() {
            this.addNewNoticeVisible = true;
        },
        edit(row) {
            this.editNoticeVisible = true;
            this.title = row.title;
            this.content = row.content;
            this.avatorUrl = row.cover;
            this.schoolnewsId = row.id;
            this.orderNumber = row.orderNumber;
            this.newsType = row.type;
            this.pulishTime = row.pulishTime;
        },
        deleteMajor(id) {
            this.$confirm("此操作将删除该新闻, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    // this.DeleteSchoolNews(id)
                    var that = this;
                    this.$http
                        .post("/api/XOrg/AssociationNews/deleteNews", {
                            newsIds: id,
                        })
                        .then((rst) => {
                            if (rst.code === 1) {
                                that.$message({
                                    message: rst.msg,
                                    type: "success",
                                });
                                that.getSchoolNewsList();
                            }
                        });
                })
                .catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消删除",
                    });
                });
        },
        search() {
            this.getSchoolNewsList(1);
        },
        deleteAll() {
            if (this.ids.length === 0) {
                this.$message({
                    showClose: true,
                    message: "请选择新闻",
                    type: "warning",
                });
                return false;
            }
            this.$confirm("此操作将删除所选新闻, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    // DeleteSchoolNews(this.ids)
                    var that = this;
                    this.$http
                        .post("/api/XOrg/AssociationNews/deleteNews", {
                            newsIds: that.ids,
                        })
                        .then((rst) => {
                            if (rst.code === 1) {
                                this.$message({
                                    message: rst.msg,
                                    type: "success",
                                });
                                this.getSchoolNewsList();
                            }
                        });
                })
                .catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消删除",
                    });
                });
        },
    },
};
</script>

<style lang="scss">
.wlx-news-backstage-wrapper {
    .news-page-con {
        padding: 20px 0;
        text-align: center;
    }
    .dd-search-form-news {
        margin: 13px 0px 0 0;
    }
}
</style>
